import { Inject, Injectable } from '@angular/core';

/*
 * Generic model type. Allows using a hash of
 * in-app properties of the model to map to
 * database property names.
 */

@Injectable()
export class Model {
  //propMap         : Record<string, string>;

  constructor(obj: Model) {
    /*this.propMap = _propMap;

    for (let prop in obj) {
      if (this.propMap[prop]) {
        Object.defineProperty(obj, this.propMap[prop], {
          enumerable: true,
          get: () => this[this.propMap[prop]],
          set: (val) => this[this.propMap[prop]] = val
        })
      }
    }*/

    Object.assign(this, obj);
  }
}
